import { render, staticRenderFns } from "./module-config.vue?vue&type=template&id=6c860bc4&scoped=true"
import script from "./module-config.vue?vue&type=script&lang=js"
export * from "./module-config.vue?vue&type=script&lang=js"
import style0 from "./module-config.vue?vue&type=style&index=0&id=6c860bc4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c860bc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c860bc4')) {
      api.createRecord('6c860bc4', component.options)
    } else {
      api.reload('6c860bc4', component.options)
    }
    module.hot.accept("./module-config.vue?vue&type=template&id=6c860bc4&scoped=true", function () {
      api.rerender('6c860bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageconfig/components/module-config.vue"
export default component.exports